/* 
*  Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. 
*  See LICENSE in the source repository root for complete license information. 
*/

export const Configs = {
  appId: 'b82ce5c0-677d-46af-abd5-376718351231',
  scope: 'User.Read, User.ReadBasic.All, User.Read.All, User.ReadWrite, User.ReadWrite.All,Group.Read.All, Group.ReadWrite.All,Contacts.Read, Contacts.ReadWrite'
};
